import {
  validatePresence,
  validateFormat,
} from 'ember-changeset-validations/validators';

export default {
  title: [
    validatePresence(true),
    validateFormat({ type: 'string', allowBlank: false }),
  ],
  // start_date: validatePresence(true),
  // end_date: validatePresence(true),
};
